import { Col, Container, Row } from "reactstrap";

const Scholarship = () => {
  return (
    <section className="section" id="scholarship">
      <Container>
        <Row className="">
          <Col xs='12' lg='5'>
          <img
            src="assets/images/scholarship.webp" 
            alt="students-apply-for-scholarship-illustration"
            className="img-fluid" 
            loading="lazy" 
          />
          </Col>
          <Col xs='12' lg='7'>
            <h1 className="mt-3 mt-lg-0 mb-3">Info Beasiswa</h1>
            <div>
              <h2><b>Beasiswa & Funding</b></h2>
              <p>
                BHMS sering punya opsi payment plans / flexible payment 
                options dan kesempatan beasiswa tergantung intake & prestasi - cocok 
                buat kamu yang butuh bantuan biaya kuliah.               
              </p>
              <p>Salah satu nya:</p>
              <p>
                Beasiswa up to CHF 8,000 bisa kamu dapatkan, dengan syarat : membuat essay motivation letter                
              </p>
            </div>  
            <p className="note">*Hubungi bagian admissions untuk cek apakah ada scholarship khusus Indonesia / early bird offer.</p>         
          </Col>          
        </Row>
      </Container>
    </section>
  );
};

export default Scholarship;